import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { Dealer_URL } from "../../Essentials/variables";



const addDealer = createAsyncThunk('dealers/add',async(data)=>{
    // console.log(data);
    const response = await axios.post(Dealer_URL,{
        
        id:uuidv4(),
        dealerName:data.dealerName,
        ownerName:data.ownerName,
        state:data.state,
        mobileno:data.mobileno,
        email:data.email,
        password:data.password

    });
    // console.log(response.data);
    return response.data;
})

export {addDealer};
